export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20retail%20display%20with%20neatly%20arranged%20clothing%20items%20on%20wooden%20shelves%2C%20soft%20warm%20boutique%20lighting%2C%20cream%20and%20beige%20neutral%20color%20palette%2C%20modern%20minimalist%20store%20interior%2C%20lifestyle%20fashion%20merchandising%2C%20clean%20sophisticated%20aesthetic%2C%20blurred%20depth%20of%20field%2C%20peaceful%20shopping%20atmosphere%2C%20high-end%20editorial%20photography%20style&width=1600&height=900&seq=hero-bg-sugargoo-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion finds"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20 md:py-28">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 md:mb-6 leading-tight">
          Sugargoo Spreadsheet
          <span className="block text-2xl md:text-3xl lg:text-4xl font-sans font-light mt-2 opacity-90">
            The Ultimate Hub For Smart Shopping
          </span>
        </h1>
        <p className="text-background-50/85 text-sm md:text-base max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Discover thousands of curated Sugargoo finds, updated product spreadsheets, category guides,
          shipping tips, and exclusive discount codes — all in one place. Your smarter way to shop begins here.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3 bg-background-50 text-foreground-900 rounded-full text-sm md:text-base font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
          </a>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-8 md:mt-10">
          <span className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
            <i className="ri-check-line text-accent-400"></i> Updated Daily
          </span>
          <span className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
            <i className="ri-check-line text-accent-400"></i> Community Verified
          </span>
          <span className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
            <i className="ri-check-line text-accent-400"></i> Beginner Friendly
          </span>
          <span className="flex items-center gap-1.5 text-background-50/80 text-xs md:text-sm">
            <i className="ri-check-line text-accent-400"></i> Free Resources
          </span>
        </div>
      </div>
    </section>
  );
}